export default [
    {
        component: () => import(
            /* webpackChunkName: 'atencao-basica-relatorio-avaliacao-elegibilidade-admissao' */
            '@/views/atencao-basica/relatorio-avaliacao-elegibilidade-admissao/Index'
        ),
        path: 'relatorio-avaliacao-elegibilidade-admissao',
        redirect: 'relatorio-avaliacao-elegibilidade-admissao/index',
        children: [
            {
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-relatorio-avaliacao-elegibilidade-admissao' */
                    '@/views/atencao-basica/relatorio-avaliacao-elegibilidade-admissao/List'
                ),
                name: 'atencao-basica-relatorio-avaliacao-elegibilidade-admissao-index',
                path: 'index',
            },
        ],
    },
]
